import React, { useState } from "react";
import { observer } from "mobx-react";
import { Progress } from "antd";

import { DetailData } from "../../utils/formatArticleData";
import "./detail-progress.scss";
import arrowIcon from "../../images/arrow.svg";

interface Props {
  position: boolean;
  detail: DetailData;
  percent: number;
  list: any;
  getH3s: () => void;
}

const DetailProgress: React.FC<Props> = (props: Props) => {
  const { position, detail, percent, list = [], getH3s } = props;
  const [unfold, setUnfold] = useState(false);

  const clickFn = (item: HTMLElement) => {
    const container = document.querySelector(`.detail__content`);
    const items = getH3s();
    items.forEach((it: HTMLElement) => {
      if (it.innerText === item.innerText) {
        container.scrollTo({
          top: item.offsetTop - 60 - 1,
          left: 0,
          behavior: "smooth",
        });
      }
    });
    setUnfold(false);
  };

  return (
    <div className={`detail__progress-wrapper ${!position && "left-50"}`}>
      <div className="detail__progress__glass" />
      <div
        className={`detail__progress ${unfold && "detail__progress--unfold"}`}
      >
        <div className="detail__progress-circle">
          <Progress
            type="circle"
            percent={percent}
            showInfo={false}
            width={30}
            strokeWidth={16}
            strokeColor="#fff" //进度条的色彩
            trailColor="#9a9790" //未完成的分段的颜色
          />
          <div
            className="detail__progress-title"
            onClick={() => list.length > 0 && setUnfold(!unfold)}
          >
            <p>{detail.title}</p>
            {list.length > 0 && <img src={arrowIcon} alt="icon" />}
          </div>
          <div className="detail__progress-percent">{percent + "%"}</div>
        </div>
        {unfold && list.length > 0 && (
          <div className="detail__progress-list">
            {list.map((item: HTMLElement, index: number) => (
              <div key={index} onClick={() => clickFn(item)}>
                {item.innerText}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(DetailProgress);
